import { useCallback } from "react";
import { useToast } from "../context/ToastContext";

export const useShare = () => {
  const { success } = useToast();

  const share = useCallback(async ({ title, text, url }) => {
    const shareData = { title, text, url: url || window.location.href };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        if (err.name !== "AbortError") {
          fallbackCopy(shareData.url, success);
        }
      }
    } else {
      fallbackCopy(shareData.url, success);
    }
  }, [success]);

  return share;
};

const fallbackCopy = async (url, toast) => {
  try {
    await navigator.clipboard.writeText(url);
    toast("Link copied to clipboard");
  } catch {
    // last resort — prompt
    window.prompt("Copy this link:", url);
  }
};
